import axios, { AxiosInstance, CreateAxiosDefaults } from 'axios';

import { requestInterceptors, responseInterceptors } from '@app/common/inerceptors';
import { environment } from '@app/environments/environment';

export const createAxiosInstance = (config?: CreateAxiosDefaults): AxiosInstance => {
    const instance = axios.create({
        ...config,
        timeout: Number(environment.API_TIMEOUT ?? 3000),
    });

    instance.interceptors.request.use(requestInterceptors.onOpenTelemetryInterceptor);

    instance.interceptors.response.use(
        responseInterceptors.onResponseSuccess,
        responseInterceptors.onSentryResponseError,
    );

    return instance;
};
